import React, { useEffect, useMemo, useState } from "react";
import Table from "../common/Table";
import fetchData from "../../api/fetchApi";
import PageHeader from "../common/PageHeader";
import { Link, useNavigate } from "react-router-dom";

export default function PackagesTab() {
  const dir = "rtl";
  const navigate = useNavigate();

    // Add package modal state
    const [showAddModal, setShowAddModal] = useState(false);
    const [newPackage, setNewPackage] = useState({ name: '', price: '', description: '', duration_days: '' });
    const [addLoading, setAddLoading] = useState(false);
    const [addError, setAddError] = useState(null);

    // Edit package modal state
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingPackage, setEditingPackage] = useState(null);
    const [editLoading, setEditLoading] = useState(false);
    const [editError, setEditError] = useState(null);

    async function handleAddPackage(e) {
      e.preventDefault();
      setAddLoading(true);
      setAddError(null);
      try {
        await fetchData('admin/package', 'POST', JSON.stringify({
          name: newPackage.name,
          price: Number(newPackage.price),
          description: newPackage.description,
          duration_days: Number(newPackage.duration_days)
        }));
        setShowAddModal(false);
        setNewPackage({ name: '', price: '', description: '', duration_days: '' });
        await loadLaws(1, perPage); // refresh table
      } catch (err) {
        setAddError('فشل إضافة الباقة');
      } finally {
        setAddLoading(false);
      }
    }

    async function handleUpdatePackage(e) {
      e.preventDefault();
      setEditLoading(true);
      setEditError(null);
      try {
        await fetchData(`admin/package?uuid=${editingPackage.uuid}`, 'PUT', JSON.stringify({
          name: editingPackage.name,
          price: Number(editingPackage.price),
          description: editingPackage.description,
          duration_days: Number(editingPackage.duration_days)
        }));
        setShowEditModal(false);
        setEditingPackage(null);
        await loadLaws(page, perPage); // refresh table
      } catch (err) {
        setEditError('فشل تحديث الباقة');
      } finally {
        setEditLoading(false);
      }
    }

    function openEditModal(pkg) {
      setEditingPackage({ ...pkg });
      setShowEditModal(true);
    }



const [packages, setPackages] = useState([]);

const [total, setTotal] = useState(5523);
  const [dateRange] = useState({ from: "يناير 2025", to: "يونيو 2025" });


  // Server data + pagination state
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [last, setLast] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  function normalizeLaw(item) {
    return {
        ...item,
        created_at: new Date(item.created_at).toLocaleDateString("ar-EG"),
      
        };
  }

  async function loadLaws(p = page, pp = perPage) {
    try {
      setLoading(true);
      setError(null);
      const res = await fetchData(`admin/packages?page=${p}&per_page=${pp}`);
      const items = res || [];
      setRows(items.map(normalizeLaw));
      const meta = res?.meta || {};
      const current = (res?.page ?? meta.current_page ?? res.current_page ?? p);
      const per = (res?.per_page ?? pp);
      const total = (res?.total ?? meta.total);
      setTotal(total);
      const lastPage = (meta.last_page || res.last_page || (typeof total === 'number' ? Math.max(1, Math.ceil(total / per)) : 1));
      setPage(current);
      setLast(lastPage);
    } catch (e) {
      setError(e?.message || 'فشل في جلب البيانات');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadLaws(page, perPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, perPage]);

  function getPages(current, last) {
    if (last <= 3) return Array.from({ length: last }, (_, i) => i + 1);
    if (current === 1) return [1, 2, 3];
    if (current === last) return [last - 2, last - 1, last];
    return [current - 1, current, current + 1];
  }

  // Toggle status API call
  async function handleToggleStatus(row) {
    try {
      setLoading(true);
      await fetchData(`admin/package/status?uuid=${row.uuid}`, 'PUT');
      await loadLaws(page, perPage);
    } catch (e) {
      setError(e?.message || 'فشل في تحديث الحالة');
    } finally {
      setLoading(false);
    }
  }

  const columns = useMemo(() => [
 { header: "اسم الحزمة", accessor: "name" },
    { header: "السعر", accessor: "price" },
    { header: "الوصف", accessor: "description" },
    { header: "مدة الحزمة (بالأيام)", accessor: "duration_days" },
    { header: "الحالة", accessor: (row) => (row.is_active ? "نشط" : "غير نشط") },
    { header: "تاريخ الإنشاء", accessor: "created_at" },


    
  
    // { header: "رقم القانون", accessor: "lawNo" },
  ], []);

 
 

  useEffect(() => {
    async function fetchPackages() {
      try {
        const data = await fetchData("admin/packages");
        setPackages(data);
      } catch (err) {
        setError("فشل تحميل الحزم");
      } finally {
        setLoading(false);
      }
    }
    fetchPackages();
  }, []);

  if (loading) return <div>جاري التحميل...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white"dir={dir} >
          {showAddModal && (
      <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
        <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
          <h3 className="text-lg font-bold mb-4">إضافة باقة جديدة</h3>
          <form onSubmit={handleAddPackage} className="space-y-4">
            <div>
              <label className="block mb-1 text-sm">اسم الباقة</label>
              <input type="text" className="w-full border rounded-lg p-2" value={newPackage.name} onChange={e => setNewPackage({ ...newPackage, name: e.target.value })} required />
            </div>
            <div>
              <label className="block mb-1 text-sm">السعر</label>
              <input type="number" className="w-full border rounded-lg p-2" value={newPackage.price} onChange={e => setNewPackage({ ...newPackage, price: e.target.value })} required min="0" />
            </div>
            <div>
              <label className="block mb-1 text-sm">الوصف</label>
              <input type="text" className="w-full border rounded-lg p-2" value={newPackage.description} onChange={e => setNewPackage({ ...newPackage, description: e.target.value })} required />
            </div>
            <div>
              <label className="block mb-1 text-sm">مدة الباقة (بالأيام)</label>
              <input type="number" className="w-full border rounded-lg p-2" value={newPackage.duration_days} onChange={e => setNewPackage({ ...newPackage, duration_days: e.target.value })} required min="1" />
            </div>
            {addError && <div className="text-red-600 text-sm">{addError}</div>}
            <div className="flex gap-2 justify-end mt-4">
              <button type="button" className="px-4 py-2 rounded bg-gray-200" onClick={() => setShowAddModal(false)}>إلغاء</button>
              <button type="submit" className="px-4 py-2 rounded bg-[var(--Primary-Primary)] text-white"
               disabled={addLoading}>{addLoading ? 'جاري الإضافة...' : 'إضافة'}</button>
            </div>
          </form>
        </div>
      </div>
    )}

    {showEditModal && editingPackage && (
      <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
        <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
          <h3 className="text-lg font-bold mb-4">تعديل الباقة</h3>
          <form onSubmit={handleUpdatePackage} className="space-y-4">
            <div>
              <label className="block mb-1 text-sm">اسم الباقة</label>
              <input type="text" className="w-full border rounded-lg p-2" value={editingPackage.name} onChange={e => setEditingPackage({ ...editingPackage, name: e.target.value })} required />
            </div>
            <div>
              <label className="block mb-1 text-sm">السعر</label>
              <input type="number" className="w-full border rounded-lg p-2" value={editingPackage.price} onChange={e => setEditingPackage({ ...editingPackage, price: e.target.value })} required min="0" />
            </div>
            <div>
              <label className="block mb-1 text-sm">الوصف</label>
              <input type="text" className="w-full border rounded-lg p-2" value={editingPackage.description} onChange={e => setEditingPackage({ ...editingPackage, description: e.target.value })} required />
            </div>
            <div>
              <label className="block mb-1 text-sm">مدة الباقة (بالأيام)</label>
              <input type="number" className="w-full border rounded-lg p-2" value={editingPackage.duration_days} onChange={e => setEditingPackage({ ...editingPackage, duration_days: e.target.value })} required min="1" />
            </div>
            {editError && <div className="text-red-600 text-sm">{editError}</div>}
            <div className="flex gap-2 justify-end mt-4">
              <button type="button" className="px-4 py-2 rounded bg-gray-200" onClick={() => setShowEditModal(false)}>إلغاء</button>
              <button type="submit" className="px-4 py-2 rounded bg-[var(--Primary-Primary)] text-white"
               disabled={editLoading}>{editLoading ? 'جاري التحديث...' : 'تحديث'}</button>
            </div>
          </form>
        </div>
      </div>
    )}
         <PageHeader title="إجمالي الحزم"
          total={
         2
         } stats={[]}>
           <button className="px-4 py-2.5 rounded-lg text-white bg-[var(--Primary-Primary)] shadow-sm text-sm md:text-base flex" onClick={() => setShowAddModal(true)}>
            
             إضافة باقة جديدة
           </button>
         
         </PageHeader>
   
         {/* Table card */}
         <Table
           columns={columns}
           rows={rows}
           actions={[{ label: "تصدير" }, { label: "تصفية" }]}
           pagination={{
             label: `الصفحة ${page} من ${last}`,
             pages: getPages(page, last),
             current: page,
             last,
             perPage,
             onPageChange: (n) => {
               if (n >= 1 && n <= last) setPage(n);
             },
             onPerPageChange: (n) => {
               setPerPage(n);
               setPage(1);
             },
             // onRowClick: (r) => navigate(`/laws/${r.uuid || r.id}`),
             // onEdit: handleEdit,
             // onStopPublish: handleStopPublish,
             // onDelete: handleDelete,
             
           }}   act= {[
            {
                 label: <div className="flex items-center gap-2">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path d="M7.33341 2.66646H4.80008C4.05334 2.66646 3.67998 2.66646 3.39476 2.81179C3.14388 2.93962 2.9399 3.14359 2.81207 3.39448C2.66675 3.67969 2.66675 4.05306 2.66675 4.7998V11.1998C2.66675 11.9465 2.66675 12.3199 2.81207 12.6051C2.9399 12.856 3.14388 13.06 3.39476 13.1878C3.67998 13.3331 4.05334 13.3331 4.80008 13.3331H11.2001C11.9468 13.3331 12.3202 13.3331 12.6054 13.1878C12.8563 13.06 13.0603 12.856 13.1881 12.6051C13.3334 12.3199 13.3334 11.9465 13.3334 11.1998V8.33313M10.3334 3.66646L12.219 5.55208M7.17524 6.82464L11.6074 2.39248C12.1281 1.87178 12.9723 1.87178 13.493 2.39248C14.0137 2.91318 14.0137 3.7574 13.493 4.27809L8.91837 8.85274C8.41061 9.3605 8.15673 9.61438 7.86755 9.81629C7.61087 9.9955 7.33403 10.144 7.04273 10.2586C6.71455 10.3878 6.3626 10.4588 5.6587 10.6008L5.33342 10.6665L5.36505 10.445C5.47699 9.66144 5.53296 9.26965 5.66027 8.90387C5.77325 8.5793 5.92758 8.27063 6.11946 7.98551C6.33569 7.66419 6.61554 7.38434 7.17524 6.82464Z" stroke="#1A6AB3" stroke-linecap="round" stroke-linejoin="round"/>
   </svg> <p className="text-[#1A6AB3]">
     تعديل 
     </p></div>
   ,
                 onClick: (row) => openEditModal(row)
               },
  //              {
  //                label: <div className="flex items-center gap-2">
   
   
  //  <p className="text-[#15936E]">
  //    تعديل الحالة
  //  </p>
  //  </div>,
  //                onClick: (row) => handleToggleStatus(row)
  //              },
  //              {
  //                label: <div className="flex items-center gap-2">
  //                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  //  <path d="M14.6667 3.33325H11.3334L10.6667 2.66659H5.33341L4.66675 3.33325H1.33341M12.6667 3.33325V12.6666C12.6667 13.1199 12.5261 13.5559 12.2192 13.8628C11.9123 14.1697 11.4763 14.3103 11.0231 14.3103H4.97608C4.52285 14.3103 4.08686 14.1697 3.77996 13.8628C
  //  3.47307 13.5559 3.33241 13.1199 3.33241 12.6666V3.33325H12.6667Z" stroke="#E02424" stroke-linecap="round" stroke-linejoin="round"/>
  //  <path d="M6.66675 7.33325V11.3333" stroke="#E02424" stroke-linecap="round" stroke-linejoin="round"/>
  //  <path d="M9.33325 7.33325V11.3333" stroke="#E02424" stroke-linecap="round" stroke-linejoin="round"/>
  //  </svg>
  //   <p className="text-[#E02424]">
  //      حذف القانون
  //    </p></div>,
     
  //                onClick: (row) => {}
   
  //              }
   
               ]}
         />
   
         {loading && (
           <div className="mt-4 text-center text-sm text-gray-500">جاري التحميل...</div>
         )}
         {error && (
           <div className="mt-2 text-center text-sm text-red-600">{error}</div>
         )}
       </div>
   
  
  );
}
